var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.campaign)?_c('div',{attrs:{"id":"commercant-banner"}},[_c('div',{staticClass:"content",style:(_vm.styles)},[_c('h2',[_vm._v(_vm._s(_vm.campaign.getName(_vm.$l)))]),_c('button',{attrs:{"type":"button"},on:{"click":_vm.loadProducts}},[_vm._v(" "+_vm._s(_vm.$t('shop.seeProducts'))+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }